import { render, staticRenderFns } from "./ProductFormModal.vue?vue&type=template&id=9c00e6d8&"
import script from "./ProductFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports